<mat-dialog-content>
  <span class="text-red-400" style="font-size: larger">You've gone idle. You will be logged out shortly.</span>
</mat-dialog-content>
